import { useDisclosure } from "@chakra-ui/core"
import React from "react"
import { JudgeMeReview } from "../../typings"
import { Button, ButtonProps } from "../Buttons"
import ReviewsModal from "../ReviewsModal"
import Stars from "../Stars"
import Body from "../typography/Body"

type ReviewsButtonProps = Omit<ButtonProps, "children"> & {
  bikeName: string
  rating?: number
  reviewCount?: number
  reviews: JudgeMeReview[]
  productId?: number
  loadMoreReviews?: VoidFunction
  isLoadingMore?: boolean
}

export default function ReviewsButton({
  bikeName,
  rating,
  reviewCount = 0,
  reviews,
  productId,
  loadMoreReviews,
  isLoadingMore,
  ...props
}: ReviewsButtonProps) {
  const modal = useDisclosure()
  return (
    <>
      <Button
        {...props}
        pl="0"
        pr="0"
        w="fit-content"
        theme="tertiary"
        alignItems="center"
        justifyContent="center"
        flexWrap="wrap"
        onClick={modal.onOpen}
        border="none"
        _hover={{ bg: "none" }}
        h="unset"
      >
        <Stars value={rating} mr="0.9531rem" />
        <Body
          size="md"
          color="primary"
          h="1.25rem"
          fontWeight="400"
          textTransform="none"
        >
          {reviewCount} Reviews
        </Body>
      </Button>
      <ReviewsModal
        bikeName={bikeName}
        rating={rating}
        reviews={reviews}
        productId={productId}
        isOpen={modal.isOpen}
        onClose={modal.onClose}
        loadMoreReviews={loadMoreReviews}
        isLoadingMore={isLoadingMore}
      />
    </>
  )
}
